import React, { useEffect, useState } from "react";
import {
  Action
} from "@thoughtspot/visual-embed-sdk";
import { GetPageByPage, GetLanguageTS } from "../../../helpers/utils";
import { SpotterEmbed } from "@thoughtspot/visual-embed-sdk/react";
import { useAppState } from "../../../stores";
import { Mixpanel } from "../../../services/mixpanel/mixpanel.service";
import { useLocale } from "../../../locales";

const Spotter = () => {
  const { configThoughtSpot } = useAppState((state) => state.user);
  const [locale, setLocale] = useState(GetLanguageTS(configThoughtSpot?.locale));
  const [runtimeFilters, setRuntimeFilters] = React.useState(configThoughtSpot?.runtimeFilters);
  const { formatMessage } = useLocale();

  const getWorksheetId = () => {
    let worksheetId = '';
    switch (configThoughtSpot?.locale) {
      case 'es':
        worksheetId = '191dae60-9f99-41eb-bbb3-badadb27c1b1'; // Spanish worksheet ID
        break;
      case 'en':
        worksheetId = '7138fdd5-41d8-4f46-8a4f-a7e02635e80b'; // English worksheet ID
        break;
      case 'pt':
        worksheetId = '606bc32b-90a5-46f9-8f0b-6cdebc57e05b'; // Portuguese worksheet ID
        break;
    }
    console.log('Spotter worksheetId:', worksheetId);
    
    return worksheetId;
  }

  useEffect(() => {
    if (!configThoughtSpot) return;
    console.log('spotter:runtimeFilters', configThoughtSpot?.runtimeFilters);
  }, [configThoughtSpot])

  return (
    <div style={{ height: '100%' }}>
      <SpotterEmbed
        className="search-content"
        hideSourceSelection={true}
        disableSourceSelection={true}
        worksheetId={getWorksheetId()}
        searchOptions={{
          searchQuery: ""
        }}
        frameParams={{
          'width': '100%',
          'height': '100%'
        }}
        runtimeFilters={configThoughtSpot?.runtimeFilters?.map((f: any) => ({
          ...f,
          values: f.values.map((v: any) => String(v))
        }))}
        locale={locale}
        hiddenActions={[
          Action.Save, Action.Edit, Action.PreviewDataSpotter,
          Action.SpotterFeedback, Action.EditPreviousPrompt,
          Action.DeletePreviousPrompt, 
          Action.SyncToSheets, Action.SyncToOtherApps, Action.ManagePipelines
        ]}
        customizations={{
          content: {
            stringIDs: {
              "convAssist.landingpage.title": formatMessage({ id: 'global.title.spotter.title' }),
              "convAssist.landingpage.description1": formatMessage({ id: 'global.title.spotter.description' }),
              "convAssist.landingpage.description2": " "
            }
          },
          style: {
            customCSS: {
              rules_UNSTABLE: {
                '.landing-page-module__landingAiIcon use, .chat-module__spotterIcon use': {
                  display: 'none',
                },
                '.landing-page-module__landingAiIcon, .chat-module__spotterIcon': {
                  'background-image': "url('https://aivo-assets.s3.amazonaws.com/analytic-embed/images/virtual-assistant-logo-sm.svg') !important",
                  'background-size': 'contain',
                  'background-repeat': 'no-repeat',
                  'background-position': 'center'
                },
                '.landing-page-module__landingAiIcon': {
                  width: '72px !important',
                  height: '72px !important',
                },
                '.chat-module__instructionsButton': {
                  'display': 'none'
                }
              }
            }
          }
        }}
        onLoad={() => window.parent.postMessage({ event_id: 'load-ts' }, '*')}
        onInit={() => {
          Mixpanel.track('access-spotter-ts', {});
        }}
      />
    </div>
  );
};

export default Spotter;
